import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1625 7.99512H2.60001M8.69376 12.8701L13.2844 8.27949C13.3588 8.20355 13.4005 8.10145 13.4005 7.99512C13.4005 7.88878 13.3588 7.78668 13.2844 7.71074L8.69376 3.12012",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgArrowRight;
